import "./Commandbar.scss";
import Button from "@components/Button/Button";
import React from "react";
import { Modal } from "@components/Modal/Modal";
import { useState } from "react";

interface ICommandbarProps {
    exportFn: () => void;
    saveFn: () => void;
    saveVariables: () => void;
    twigVars: string[];
}

export const Commandbar: React.FC<ICommandbarProps> = ({ exportFn, saveFn, saveVariables, twigVars }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <div className="commandbar">
                <div>
                    <Button buttonStyle="btn--secondary" onClick={saveFn}>
                        Save Draft
                    </Button>
                    <Button
                        buttonStyle="btn--secondary"
                        onClick={() => setIsOpen(true)}
                    >
                        Edit Deal Data
                    </Button>
                </div>
                <div>
                    <Button onClick={exportFn}>Export as Pdf</Button>
                </div>
            </div>
            <div className="Modal">
                <Modal
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                    saveVariables={saveVariables}
                    varNames={twigVars}
                />
            </div>
        </>
    );
};
